import { render, staticRenderFns } from "./Acceptance.vue?vue&type=template&id=4dcee6b2&"
import script from "./Acceptance.vue?vue&type=script&lang=ts&"
export * from "./Acceptance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dcee6b2')) {
      api.createRecord('4dcee6b2', component.options)
    } else {
      api.reload('4dcee6b2', component.options)
    }
    module.hot.accept("./Acceptance.vue?vue&type=template&id=4dcee6b2&", function () {
      api.rerender('4dcee6b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/Field/Acceptance.vue"
export default component.exports